<template>
  <div class="shop-header" v-if="shopdata">
    <div class="info">
      <div class="logo">
        <img :src="shopdata.logo" />
      </div>
      <div class="shop-base">
        <p class="name">{{ shopdata.name }}</p>
        <div class="desc">
          <div class="star">
            <van-icon :name="i <= shopdata.star ? 'star':'star-o'" v-for="i in 5" :key="i" color="#faab0c" /> {{ shopdata.star }}
          </div>
          <div class="quantity">{{ shopdata.collection_quantity }} 收藏</div>
          <div class="quantity">{{ shopdata.positive_review }} 好评</div>
        </div>
      </div>
    </div>
    <div class="shop-data">
      <div class="item">
        <p>日访问量</p>
        {{ shopdata.daily_visits  }}</div>
      <div class="item"><p>已售出</p> {{ shopdata.sold_count }}</div>
      <div class="item"><p>信用</p> {{ shopdata.credit }}</div>
    </div>
    <div class="remark">
      <p class="title">{{ shopdata.title }}</p>
      <div class="bewrite">{{ shopdata.bewrite }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopHeaderView',
  data () {
    return {
      shopid: null,
      shopdata: null
    }
  },
  mounted () {
    this.shopid = this.$route.query.id
    if (this.shopid) {
      this.getData()
    }
  },
  methods:{
    async getData(){
        await this.$http({
        method: 'post',
        url: 'getShopInfo',
        data: { shop_id: this.shopid }
      }).then(res => {
        this.shopdata = res.data.shop_info
        console.log(res)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.shop-header {
  margin: 40px 10px 10px;
  padding: 15px 0px 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .info {
    display: flex;
    gap: 10px;
    margin: 0px 12px;
    .logo {
        width: 50px;
        height: 50px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .shop-base {
        flex: 1;
        position: relative;
        .name {
            font-size: 20px;
            font-weight: 600;
        }
        .desc {
            display: flex;
            gap: 10px;
            font-size: 14px;
            margin-top: 5px;
            .star {
                height: 18px;
                line-height: 18px;
                flex: 1;
                color: #faab0c;
            }
            .quantity{
                height: 18px;
                line-height: 18px;
                flex: 1;
                color: #faab0c;
            }
        }
    }
  }
  .shop-data{
    display: flex;
    gap: 5px;
    margin: 10px 12px;
    text-align: center;
    border-top: 1px solid #dcdee0;
    padding-top: 10px;
    .item {
        flex: 1;
        color: #faab0c;
        font-size: 18px;
        font-weight: 550;
        p {
            color: #000;
            font-size: 15px;
            line-height: 2;
        }
    }
  }
  .remark {
    background: #daecf7;
    padding:10px 15px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    p.title {
        font-weight: 600;
        margin: 8px 0;
    }
    .bewrite {
        font-size: 14px;
        color: #969799;
    }
  }
}
</style>
